const COOKIE_PREFIX = process.env.COOKIE_PREFIX || "_ara";
const COOKIE_MAX_AGE = 60 * 60 * 24 * 1000;

export const CLARITY_USER_ROLE_COOKIE = `${COOKIE_PREFIX}_clarity_user_role`;
export const COLLAPSED_COOKIE = `${COOKIE_PREFIX}_cllpsd`;
export const CROP_CYCLE_COOKIE = `${COOKIE_PREFIX}_crop_cycle`;
export const LOCALE_COOKIE = `${COOKIE_PREFIX}_locale`;
export const LOCALITY_COOKIE = `${COOKIE_PREFIX}_locality`;
export const TENANT_COOKIE = `${COOKIE_PREFIX}_tenant`;
export const THEME_COOKIE = `${COOKIE_PREFIX}_theme_mode`;

export const DefaultCookieOptions = {
  domain: process.env.DOMAIN,
  maxAge: COOKIE_MAX_AGE,
  path: "/",
};
